import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="removable"
export default class extends Controller {
  handle() {
    this.element.remove();
  }
}
